import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const REVIEWS = [
  {
    name: "Sarah M.",
    role: "Radio setup",
    initials: "SM",
    color: "#3B82F6",
    text: "Got my car radio and streaming app set up in a single day. Super smooth, clear one-time price, and no monthly fees — exactly what I wanted.",
  },
  {
    name: "James T.",
    role: "Web & app development",
    initials: "JT",
    color: "#0EA5A3",
    text: "They built our landing page and booking app fast, with great communication throughout. The one-time pricing made budgeting easy.",
  },
  {
    name: "Priya K.",
    role: "Antivirus (3 devices)",
    initials: "PK",
    color: "#8B5CF6",
    text: "Bought antivirus for 3 devices — genuine license, installed and activated for me. Support answered every question. Highly recommend.",
  },
];

export default function Testimonials() {
  return (
    <section id="reviews" className="bg-white border-b border-[#E2E8F0]" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 py-24">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#3B82F6]">What customers say</p>
            <h2 className="font-display text-3xl sm:text-4xl tracking-tight uppercase mt-3 text-[#0F172A]">Loved by our customers</h2>
          </div>
          <div className="flex items-center gap-3" data-testid="reviews-rating">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-5 w-5 text-[#F59E0B] fill-[#F59E0B]" />
              ))}
            </div>
            <span className="text-sm text-[#475569]"><span className="font-bold text-[#0F172A]">4.8/5</span> from 1,000+ customers</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
          {REVIEWS.map((r, i) => (
            <motion.div
              key={r.name}
              initial={{ opacity: 0, y: 22 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: i * 0.1 }}
              className="relative rounded-2xl bg-[#F5F7FC] border border-[#E2E8F0] p-7 flex flex-col"
              data-testid={`review-card-${i}`}
            >
              <Quote className="h-8 w-8 text-[#3B82F6]/20 absolute top-6 right-6" />
              <div className="flex text-[#F59E0B]">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} className="h-4 w-4 fill-[#F59E0B]" />
                ))}
              </div>
              <p className="text-[#334155] mt-4 leading-relaxed flex-1">“{r.text}”</p>
              <div className="flex items-center gap-3 mt-6">
                <span className="h-10 w-10 rounded-full grid place-items-center text-white text-sm font-bold" style={{ backgroundColor: r.color }}>
                  {r.initials}
                </span>
                <div>
                  <p className="text-sm font-bold text-[#0F172A]">{r.name}</p>
                  <p className="text-xs text-[#475569]">{r.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
